if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    connectedCallback() {
      const form = this.querySelector('form');
      if (!form || this.form === form) return;
      this.form = form;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    cartUrl() {
      return window.routes?.cart_url || (window.Shopify?.routes?.root || '/') + 'cart';
    }

    async onSubmitHandler(event) {
      event.preventDefault();
      if (this.submitting) return;
      const button = this.querySelector('[type="submit"]');
      if (!button || button.disabled) return;
      this.submitting = true;
      button.disabled = true;
      button.classList.add('loading');
      button.setAttribute('aria-busy', 'true');
      let added = false;
      let timeout;
      try {
        this.handleErrorMessage();
        const body = new FormData(this.form);
        if (!body.get('id')) throw new Error('Välj en produktvariant innan du lägger varan i varukorgen.');
        const cartItems = document.querySelector('cart-items');
        const drawer = document.querySelector('cart-notification');
        const target = cartItems || drawer;
        if (typeof target?.getSectionsToRender === 'function') {
          const sections = target.getSectionsToRender().map(section => section.section || section.id);
          body.set('sections', [...new Set(sections)].slice(0, 5).join(','));
          body.set('sections_url', window.location.pathname);
        }
        if (typeof drawer?.setActiveElement === 'function') drawer.setActiveElement(button);
        window.SvemobCartMinimum?.pending();
        const controller = new AbortController();
        timeout = window.setTimeout(() => controller.abort(), 15000);
        const addUrl = (window.routes?.cart_add_url || (window.Shopify?.routes?.root || '/') + 'cart/add').replace(/\.js$/, '') + '.js';
        const response = await fetch(addUrl, {
          method: 'POST', headers: { Accept: 'application/json' },
          body, credentials: 'same-origin', signal: controller.signal
        });
        const state = await response.json();
        if (!response.ok || state.status || state.errors) {
          throw new Error(typeof state.description === 'string' ? state.description : typeof state.errors === 'string' ? state.errors : 'Varan kunde inte läggas i varukorgen. Kontrollera antal och lagerstatus.');
        }
        added = true;
        // add.js returns line items, not the cart total or cart item count.
        const cartResponse = await fetch(this.cartUrl() + '.js', {
          headers: { Accept: 'application/json' }, credentials: 'same-origin',
          cache: 'no-store', signal: controller.signal
        });
        if (!cartResponse.ok) throw new Error('Varukorgen kunde inte uppdateras.');
        const cart = await cartResponse.json();
        const fullState = { ...cart, sections: state.sections };
        if (typeof target?.renderContents !== 'function' || target.renderContents(fullState) === false) {
          window.location.assign(this.cartUrl());
          return;
        }
        window.SvemobCartMinimum?.update(cart);
        document.getElementById('quickViewWrapper')?.classList.remove('show__modal');
        document.body.classList.remove('overflow-hidden');
      } catch (error) {
        if (added) {
          // The add succeeded: use the server-rendered cart, never send a second add.
          window.location.assign(this.cartUrl());
        } else {
          this.handleErrorMessage(error.name === 'AbortError'
            ? 'Det tar för lång tid att få svar. Kontrollera varukorgen innan du försöker igen.'
            : error instanceof TypeError
              ? 'Anslutningen avbröts. Kontrollera varukorgen innan du försöker igen.'
              : error.message);
          window.SvemobCartMinimum?.sync();
        }
      } finally {
        window.clearTimeout(timeout);
        this.submitting = false;
        button.classList.remove('loading');
        button.removeAttribute('aria-busy');
        button.disabled = false;
      }
    }

    handleErrorMessage(message = '') {
      let wrapper = this.querySelector('.product-form__error-message-wrapper');
      if (!wrapper && !message) return;
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'product-form__error-message-wrapper';
        wrapper.setAttribute('role', 'alert');
        const text = document.createElement('span');
        text.className = 'product-form__error-message';
        wrapper.append(text);
        this.append(wrapper);
      }
      wrapper.hidden = !message;
      wrapper.classList.toggle('no-js-inline', !message);
      const text = wrapper.querySelector('.product-form__error-message');
      if (text) text.textContent = message;
      let link = wrapper.querySelector('[data-cart-error-link]');
      if (message && !link) {
        link = document.createElement('a');
        link.dataset.cartErrorLink = '';
        link.href = this.cartUrl();
        link.textContent = 'Visa varukorgen';
        wrapper.append(link);
      }
    }
  });
}
